import { useMemo, useState } from 'react';
import { useParams } from 'react-router';
import useTopic from '../../hooks/useTopics';
import Breadcrumbs from '../../components/ui/Breadcrumbs';
import TopicList from '../../components/ui/TopicList';
import Button from '../../components/ui/Button';
import CourseQuizModal from '../../components/modals/CreateCourseQuizModal';
import { useLoginPrompt } from '../../contexts/LoginPromptContext';
import { useAuth } from '../../contexts/authContext';

function CourseTopicPage() {
  let { course_id } = useParams();
  let { topics, loading, error } = useTopic({ course_id });
  let { user } = useAuth()
  let { openLoginPrompt } = useLoginPrompt()

  const [isQuizModalOpen, setQuizModalOpen] = useState(false);

  let course_detail = useMemo(() => (topics[0]?.course_detail), [topics]);

  const breadcrumbItems = [
    { text: 'Discover', url: '/discover' },
    { text: course_detail?.code || 'Loading...' }
  ];

  let handleOpenQuizModal = ()=>{
    if (!user) {
      openLoginPrompt();
      return;
    }

    setQuizModalOpen(true)
  }

  return (
    <div className="max-w-7xl mx-auto p-4 mt-10">
      <Breadcrumbs items={breadcrumbItems} className="mb-5" />

      <div className="flex justify-between items-center mb-6">
        <h1 className="text-3xl md:text-4xl font-bold text-gray-800">
          {course_detail?.title}
          <span className="text-purple-600 block md:inline"> [{course_detail?.code}]</span>
        </h1>
        <Button onClick={handleOpenQuizModal}>Create Course Quiz</Button>
      </div>

      <div className="bg-gradient-to-r from-purple-50 to-indigo-50 rounded-2xl p-8 mb-10">
        <div className="max-w-2xl">
          <p className="text-gray-600 mb-6">{course_detail?.description}</p>
        </div>
      </div>

      {loading ? (
        <div className="text-center py-4">Loading...</div>
      ) : error ? (
        <div className="text-center py-4 text-red-500">Error loading topics</div>
      ) : topics.length === 0 ? (
        <div className="text-center py-4 text-gray-500">No topics found</div>
      ) : (
        <>
          <h2 className="text-2xl font-bold text-gray-800">Topics</h2>
          <TopicList topics={topics} />
        </>
      )}

      {/* Quiz Modal */}
      <CourseQuizModal
        isOpen={isQuizModalOpen}
        onClose={() => setQuizModalOpen(false)}
        courseId={course_id}
        courseTitle={course_detail?.title}
      />
    </div>
  );
}

export default CourseTopicPage;
